import "./../PersonalOrders/PersonalOrders.scss";
import { IClientRequestsResponse } from "models/cabinet";
import moment from "moment";
import EastIcon from "@mui/icons-material/East";
interface PersonalOrdersProps {
  orders: IClientRequestsResponse | undefined;
}
const PersonalOrdersMobile = ({ orders }: PersonalOrdersProps) => {
  const orderList = orders?.items || [];
  const operationTypes = (type: string) => {
    if (type === "FIAT_TO_CRYPTO") {
      return (
        <div className="operation-row">
          Fiat <EastIcon /> Crypto
        </div>
      );
    } else if (type === "CRYPTO_TO_FIAT") {
      return (
        <div className="operation-row">
          Crypto <EastIcon /> Fiat
        </div>
      );
    }
  };
  const statusClassNames = (status: string) => {
    switch (status) {
      case "Processing":
        return "yellow-status status";
      case "Failed":
        return "red-status status";
      case "Approved":
        return "yellow-status status";
      default:
        return "status";
    }
  }
  return (
    <div className="personal-orders">
      {orderList.length === 0 ? (
        <div className="no-orders">No transactions yet</div>
      ) : (
        <>
          {orderList.map((data, index) => (
            <div className="orders-data" key={index}>
              <div className="order-row">
                <div className="info-column">
                  <div className="title">Date / Time</div>
                  <div>
                    {moment(data.date).utc().format("DD.MM.YYYY HH:mm:ss")}
                  </div>
                </div>
                <div className="info-column right">
                  <div className="title">Status</div>
                  <div className={statusClassNames(data.status)}>{data.status}</div>
                </div>
              </div>
              <div className="order-row">
                <div className="info-column">
                  <div className="title">Order ID</div>
                  <div>{data.id}</div>
                </div>
                <div className="info-column right">
                  <div className="title">Operation Type</div>
                  <div>{operationTypes(data.operationType)}</div>
                </div>
              </div>
              <div className="order-row">
                <div className="info-column">
                  <div className="title">Paid</div>
                  <div>
                    <span>
                      {data.paid.match(/^(\d+\.\d{0,6})/)?.[0] ?? "0.000000"}
                    </span>{" "}
                    {data.from}
                  </div>
                </div>
                <div className="info-column right">
                  <div className="title">Sent</div>
                  <div>
                    <span>
                      {data.sent.match(/^(\d+\.\d{0,6})/)?.[0] ?? "0.000000"}
                    </span>{" "}
                    {data.to}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default PersonalOrdersMobile;
